function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.10612 18.415C3.45465 17.1326 5.28365 16.4121 7.19075 16.4121H18.696C20.6031 16.4121 22.4321 17.1326 23.7806 18.415C25.1291 19.6974 25.8867 21.4368 25.8867 23.2504V25.9857C25.8867 26.741 25.2428 27.3533 24.4486 27.3533C23.6543 27.3533 23.0104 26.741 23.0104 25.9857V23.2504C23.0104 22.1622 22.5559 21.1186 21.7467 20.3491C20.9376 19.5797 19.8402 19.1474 18.696 19.1474H7.19075C6.04649 19.1474 4.94909 19.5797 4.13998 20.3491C3.33086 21.1186 2.8763 22.1622 2.8763 23.2504V25.9857C2.8763 26.741 2.23242 27.3533 1.43815 27.3533C0.643882 27.3533 0 26.741 0 25.9857V23.2504C0 21.4368 0.757595 19.6974 2.10612 18.415Z",
  fill: "#1ECD96"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.9432 2.73531C10.5604 2.73531 8.62874 4.57226 8.62874 6.83826C8.62874 9.10426 10.5604 10.9412 12.9432 10.9412C15.326 10.9412 17.2576 9.10426 17.2576 6.83826C17.2576 4.57226 15.326 2.73531 12.9432 2.73531ZM5.75244 6.83826C5.75244 3.06159 8.97185 0 12.9432 0C16.9145 0 20.1339 3.06159 20.1339 6.83826C20.1339 10.6149 16.9145 13.6765 12.9432 13.6765C8.97185 13.6765 5.75244 10.6149 5.75244 6.83826Z",
  fill: "#1ECD96"
});

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.686d5e50.svg";
export { ForwardRef as ReactComponent };